import {createAsyncThunk} from '@reduxjs/toolkit'
import {fetchSubCategory} from 'sr/utils/api/fetchSubCategory'
export const fetchSubCatData = createAsyncThunk(
  'subCategory/fetchSubCatData',
  async (payload: any) => {
    const {totalResults} = await fetchSubCategory({})
    return totalResults
  },
  {
    condition: (_payload, { getState }) => {
      const state = getState() as { subCatetory: { status: string } }
      return state.subCatetory.status !== 'succeeded' && state.subCatetory.status !== 'loading'
    },
  }
)
